import React from "react";
import { AccordionTitleView, TitleView } from "../../../components";
import { Accordion, AccordionContent, AccordionTitle, Image } from "semantic-ui-react";
import { images } from "../../../assets/images";
import Packaging from "../../packagingSimulation/component/packaging/pakaging";
import { PACKAGE_TYPES } from "../../../config/constants";
import {
  useCreatePackagingSimulation,
  useDeletePackagingSimulation,
  useUpdatePackagingSimulation,
  useUpdatePackagingSimulationDetails
} from "../../../api/simulation/processGateSimulation/packaging";

const IngredientPackagingDetails: React.FC = () => {
  const processGateId = ""; // Initialize with an appropriate value
  const { mutate: mutatePackingDetails } = useUpdatePackagingSimulationDetails();
  const { mutate: mutateCreatePackagingSimulation, isLoading: isLoadingCreatePackagingSimulation } =
    useCreatePackagingSimulation();
  const { mutate: mutateUpdatePackagingSimulation, isLoading: isLoadingUpdatePackagingSimulation } =
    useUpdatePackagingSimulation();
  const { mutate: mutateDeletePackagingSimulation, isLoading: isLoadingDeletePackagingSimulation } =
    useDeletePackagingSimulation();
    const [activeIndex, setActiveIndex] = React.useState(1);
  return (
    <div>
      <Accordion>
        <AccordionTitle
          active={true}
          onClick={() => {
            return true;
          }}
        >
          <AccordionTitleView accordionEnabled={true} title={"Packaging information"} />
        </AccordionTitle>
        <AccordionContent active={true} className="mb-3">
          <div>
            <Accordion>
              <AccordionTitle
                active={activeIndex === 1}
                index={1}
                onClick={() => {
                  setActiveIndex(activeIndex === 1 ? 0 : 1);
                }}
              >
                <p className="packagingTitleText">
                  Please add information about how your ingredients are packaged at each level
                  following the GS1 guidelines. Use this image as a reference.
                </p>
              </AccordionTitle>
              <AccordionContent active={activeIndex === 1}>
                <Image src={images.PackingProcess} />
              </AccordionContent>
            </Accordion>
            {PACKAGE_TYPES.map(type => {
              const packagingType = type as PackagingType;
              return (
                <Packaging
                  key={packagingType}
                  isSimiulationDrawing={true}
                  packagingData={[] as any}
                  packagingType={packagingType}
                  newPackagingData={undefined}
                  setNewPackagingData={() => {}}
                  packagingMaterials={[]}
                  weightUnit={undefined}
                  setUnitSizeWeightUnit={() => {}}
                  createPackaging={(packagingData: any) => {
                    mutateCreatePackagingSimulation({
                      data: { ...packagingData, changeStatus: true },
                      ...packagingData,
                      processGateId: "",
                      packagingId: packagingData._id
                    });
                  }}
                  updatePackaging={(packagingData: any) => {
                    mutateUpdatePackagingSimulation({
                      data: {
                        ...packagingData,
                        packagingId: packagingData._id,
                        changeStatus: true
                      },
                      ...packagingData,
                      processGateId,
                      packagingId: packagingData._id
                    });
                  }}
                  deletePackaging={(packagingData: any) => {
                    mutateDeletePackagingSimulation({
                      ...packagingData,
                      processGateId,
                      packagingId: packagingData._id
                    });
                  }}
                  updatePackingDetails={mutatePackingDetails}
                  isView={false}
                />
              );
            })}
          </div>
        </AccordionContent>
      </Accordion>
    </div>
  );
};

export default IngredientPackagingDetails;
